const VI_NUMBER = new Intl.NumberFormat("vi-VN");

/**
 * Số liệu nghiệp vụ đọc theo định dạng Việt Nam (2.374). Tách khỏi component để file
 * component chỉ export component (fast-refresh) và để mọi màn cemeteries dùng chung một
 * cách hiển thị số.
 */
export function formatCount(value: number): string {
  return VI_NUMBER.format(value);
}
